'use client';

import Image from '@/components/Image';

interface CandyTopBannerProps {
  pageData: any;
}

export default function CandyTopBannerMobile({ pageData }: CandyTopBannerProps) {
  const banner1 = pageData?.banner1 || {};
  const banner2 = pageData?.banner2 || {};
  const banner3 = pageData?.banner3 || {};

  const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0;

  if (isEmpty(pageData)) return null;

  return (
    <div className="top-banner w-full">
      {/* Banner1 - 移动端布局 */}
      {!isEmpty(banner1) && (
        <div className="banner1 flex relative h-[171.5px] px-[8px] pr-[22px] box-border bg-white">
          <Image
            src={banner1.banner_image}
            alt="Zeelool optical eyeglasses online store1"
            width={200}
            height={121}
            className="left-image block h-[121.5px] w-auto translate-y-[22.5px]"
          />
          <h2 className="flex flex-col ml-[14.5px] font-bb text-black text-center h-[49.5px] translate-y-[43px] leading-[25px]">
            <span className="text-[30px]">{banner1.title?.split(' ')[0]}</span>
            <span className="text-[25px]">
              {banner1.title?.split(' ')[1]} {banner1.title?.split(' ')[2]}
            </span>
          </h2>
          <Image
            src={banner1.banner_image2}
            alt="Zeelool optical eyeglasses online store2"
            width={96}
            height={96}
            className="right-image absolute top-[107px] right-[13px] h-[96px] w-auto z-[12]"
          />
        </div>
      )}

      {/* Banner2 - 移动端布局 */}
      {!isEmpty(banner2) && (
        <div className="banner2 relative z-[2] bg-[#0f0f0f] border-b border-white">
          {/* 顶部图片 */}
          <div className="top-box flex justify-start items-end pt-[15px] pl-[20px]">
            <Image
              src={banner2.banner_image2}
              alt="Zeelool optical eyeglasses online store4"
              width={63}
              height={63}
              className="banner2_image2 w-[63.5px] h-auto"
            />
            <Image
              src={banner2.banner_image3}
              alt="Zeelool optical eyeglasses online store5"
              width={53}
              height={53}
              className="banner2_image3 w-[53px] h-auto pb-[5px] pl-[24px]"
            />
          </div>

          {/* 标题和内容 */}
          <h2 className="font-bb text-white text-center w-[277px] text-[40px] pt-[12px] mx-auto leading-[35px]">
            {banner2.title}
          </h2>
          <p className="w-[330px] text-center mx-auto mt-[14px] text-[#a6a6a6] text-[14px] leading-[20px]">
            {banner2.content}
          </p>

          {/* 底部图片 */}
          <div className="bottom-box relative px-[27px] pt-[20px] pb-[22px]">
            <Image
              src={banner2.banner_image}
              alt="Zeelool optical eyeglasses online store3"
              width={45}
              height={45}
              className="banner2_image absolute right-[28px] top-[15px] w-[45.5px] h-auto"
            />
            <Image
              src={banner2.banner_image4}
              alt="Zeelool optical eyeglasses online store6"
              width={69}
              height={69}
              className="banner2_image4 h-[69px] w-auto"
            />
          </div>
        </div>
      )}

      {/* Banner3 - 移动端布局 */}
      {!isEmpty(banner3) && (
        <div className="banner3 bg-[#0f0f0f] border-b border-white box-border">
          <Image
            src={banner3.banner_image}
            alt="Zeelool optical eyeglasses online store7"
            width={375}
            height={300}
            className="banner3_image w-full h-auto"
          />
          <div className="text-wrapper px-[27px] pb-[36px]">
            <h3 className="font-bb text-white text-left w-[300px] text-[40px] leading-[35px]">
              {banner3.title}
            </h3>
            <div className="text relative pt-[27.5px] text-[#a6a6a6] text-[14px] leading-[20px] text-left">
              {banner3.content}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
